import React, { useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import { DSMReportGenerate, isLoggedIn, notAuthorized } from "../../api/AuthService"
import { FETCH_SEARCH_3D_RESULT, typeDropdown } from "../../constant/Constants"
import SearchDSResults from "./SearchDSResults"

function SearchDSData(props) {
    const navigate = useNavigate()
    const { handleSetFrom, ...rest } = props;
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(false)
    const [errorFlag, setErrorFlag] = useState(1)
    const [search, setSearch] = useState({
        type: "",
        name: "",
        labelKey: ""
    })
    const [searchButtonDisable, setsearchButtonDisable] = useState(true)
    const [message, setMessage] = useState("")
    const [selectedItems, setSelectedItems] = useState([])

    const handleSelectedItems = (obj) => {
        setSelectedItems(obj)
    }

    function validateInput() {
        if (search.type === "") {
            setMessage("*Type is mandatory")
            return false
        } else {
            return true
        }
    }

    const handleSearch = () => {
        if (validateInput()) {
            setLoading(true)
            DSMReportGenerate(`${FETCH_SEARCH_3D_RESULT}`, {
                type: search.labelKey,
                name: search.name
            })
                .then((response) => {
                    if (response.data && response.data.subscriptionFields !== null) {
                        setResults(response.data.subscriptionFields)
                        setLoading(false)
                        setErrorFlag(0)
                    }
                    else {
                        setErrorFlag(1)
                        setLoading(false)
                    }

                })
                .catch((error) => {
                    if (error.response && error.response.status === 401) {
                        notAuthorized(navigate)
                        setLoading(false)
                    }
                    else {
                        setLoading(false)
                        setErrorFlag(2)
                    }
                })
        }
    }

    const handelSubmit = (e) => {
        if (!isLoggedIn()) {
            navigate("/")
        }
        e.preventDefault()
        handleSearch()
    }

    const closeSeach = (e) => {
        // For multi-select (Organization), if Select All is checked, set all result names as selectedItems
        const isMultiSelect = props.from && props.from.toLowerCase() === "organization";
        let finalSelectedItems = selectedItems;
        if (isMultiSelect && e && e.target && e.target.value === "Submit") {
            if (results.length > 0 && selectedItems.length === 0) {
                finalSelectedItems = results.map(item => item.Name);
                setSelectedItems(finalSelectedItems);
            }
        }
        // Immediately clear all state, including Name
        setSearch({ type: "", name: "", labelKey: "" });
        setResults([]);
        setMessage("");
        setLoading(false);
        setErrorFlag(1);
        setSelectedItems([]);
        handleSetFrom();
        if (finalSelectedItems.length > 0 && e && e.target && e.target.value === "Submit") {
            props.onHide(finalSelectedItems.toString());
        } else {
            props.onHide();
        }
    }

    const handleTypeChange = (selectedOption) => {
        setMessage("");
        if (selectedOption) {
            // Find the selected item in typeDropdown to get labelKey
            const selectedType = typeDropdown[props.from]?.find(item => item.value === selectedOption.value);
            setSearch((data) => ({
                ...data,
                type: selectedOption.value,
                labelKey: selectedType ? selectedType.labelKey : ""
            }));
        } else {
            setSearch((data) => ({
                ...data,
                type: "",
                labelKey: ""
            }));
        }
    }

    function handleInputChange(e) {
        setMessage("")
        const { name, value } = e.target
        setSearch((data) => ({
            ...data,
            [name]: value,
        }));
    }

    useEffect(() => {
        var isEmpty = Object.values(search).every(data => data === "");
        if (!isEmpty) {
            setsearchButtonDisable(false)
        }
        else {
            setsearchButtonDisable(true)
        }
    }, [search])

    // Convert typeDropdown options to react-select format
    const typeOptions = props.from && typeDropdown[props.from]
        ? typeDropdown[props.from].map((item) => ({
            value: item.value,
            label: item.value
        }))
        : []

    // Multi-select only for Organization
    const isMultiSelect = props.from && props.from.toLowerCase() === "organization";

    // Placeholder for selected items
    const selectedPlaceholder = selectedItems && selectedItems.length > 0
        ? (isMultiSelect ? selectedItems.join(", ") : selectedItems[0])
        : "Select from results...";

    return (
        <Modal
            {...rest}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="my-modal"
            style={{ overflowY: "hidden" }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton onHide={closeSeach}>
            </Modal.Header>
            <Modal.Body>

                <Form onSubmit={handelSubmit}>
                    <Row style={{ height: "410px" }}>
                        <Col md="4" sm="5">
                            <Form.Label className="loginTextHeader" >
                                Advanced Search
                            </Form.Label>
                            <br />
                            <Col style={{ maxHeight: "350px" }}>
                                <Row className="mb-3">
                                    <Col md="12">
                                        <Form.Label className="reportLabels" id="view">
                                            Type
                                        </Form.Label>
                                        <Select
                                            name="type"
                                            options={typeOptions}
                                            isMulti={false}
                                            onChange={handleTypeChange}
                                            className="searchType"
                                            classNamePrefix="react-select"
                                            placeholder="Select type..."
                                            value={typeOptions.find(option => option.value === search.type) || null}
                                            styles={{
                                                indicatorSeparator: () => ({ display: 'none' })
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col md="12">
                                        <Form.Label className="reportLabels" id="name">
                                            Name
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            style={{ width: "100%" }}
                                            name="name"
                                            id="name"
                                            onChange={handleInputChange}
                                            value={search.name}
                                            placeholder="Enter text..."
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Row className="mt-4">
                                <Col md="12">
                                    {message && (
                                        <p style={{ color: "red", fontSize: "14px" }}>
                                            {message}
                                        </p>
                                    )}
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col md="12" style={{ textAlign: "center" }}>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        disabled={searchButtonDisable}
                                        style={{ marginRight: "10px" }}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        variant="secondary"
                                        onClick={closeSeach}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="8" sm="7">
                            {loading ?
                                <h2 style={{ textAlign: "center", color: "#0173d4", marginTop: "15%" }}>
                                    <i
                                        className="fa fa-spinner fa-spin"
                                        style={{ marginRight: "5px" }}
                                    />
                                    Loading........
                                </h2>
                                :
                                <>
                                    <SearchDSResults
                                        results={results}
                                        loading={loading}
                                        error={errorFlag}
                                        type={props.from}
                                        isMultiSelect={isMultiSelect}
                                        handleSelectedItems={handleSelectedItems}
                                    />
                                </>
                            }
                        </Col>
                    </Row>
                </Form>

            </Modal.Body>
            <Modal.Footer>
                <Button value="Submit" onClick={closeSeach}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default SearchDSData